"use strict";
// packages/contracts/src/precedencia.ts — Fase 03, Plano 04 (OPS-10).
// Tipos de arestas do grafo de precedência e campos de domínio de OPS-10.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=precedencia.js.map